import React, { useState } from 'react';
import { Check, X, Sparkles, Shield, Users, User, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function PricingPage() {
  const [isAnnual, setIsAnnual] = useState(true);
  return <div className="flex flex-col min-h-screen w-full font-inter bg-white" data-id="element-4284">
      <TopBar data-id="element-4285" />
      <Header data-id="element-4286" />

      {/* Hero Section */}
      <section className="w-full bg-white py-16 md:py-24 border-b border-gray-200" data-id="element-4287">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-4288">
          <h1 className="text-4xl md:text-6xl font-extrabold text-[#111111] mb-6 leading-tight" data-id="element-4289">
            Honest pricing. No games.
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-4290">
            No upsells. No confusing tiers. No fear-mongering. One price gets
            your whole family guided, protected, and on track.
          </p>

          {/* Monthly/Annual Toggle */}
          <div className="mt-12 flex items-center justify-center space-x-4" data-id="element-4291">
            <span className={`text-lg font-medium ${!isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-4292">
              Monthly
            </span>
            <button onClick={() => setIsAnnual(!isAnnual)} className="relative w-16 h-8 bg-#[631bb7] rounded-full p-1 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-#[631bb7]" data-id="element-4293">
              <div className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-200 ease-in-out ${isAnnual ? 'translate-x-8' : 'translate-x-0'}`} data-id="element-4294" />
            </button>
            <span className={`text-lg font-medium ${isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-4295">
              Annual <span className="text-[#631bb7] text-sm" data-id="element-4296">(Save 20%)</span>
            </span>
          </div>
        </div>
      </section>

      {/* Pricing Tiers */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24" data-id="element-4297">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4298">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-4299">
            {/* Foundation (Free) */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full" data-id="element-4300">
              <div className="mb-6" data-id="element-4301">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-4302">
                  Foundation
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-4303">
                  Essential basics for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-4304">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-4305">
                  $0
                </span>
                <span className="text-gray-500 ml-1" data-id="element-4306">/forever</span>
              </div>
              <Link to="/onboarding" className="w-full block text-center py-3 px-4 bg-gray-100 text-[#111111] font-bold rounded-lg hover:bg-gray-200 transition-colors mb-8" data-id="element-4307">
                Start for Free
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-4308">
                <li className="flex items-start" data-id="element-4309">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4310" />
                  <span className="text-gray-700 text-sm" data-id="element-4311">For 1 person</span>
                </li>
                <li className="flex items-start" data-id="element-4312">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4313" />
                  <span className="text-gray-700 text-sm" data-id="element-4314">
                    See where you stand with a free safety checkup
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4315">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4316" />
                  <span className="text-gray-700 text-sm" data-id="element-4317">
                    Access your first critical walkthroughs
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4318">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4319" />
                  <span className="text-gray-700 text-sm" data-id="element-4320">
                    No credit card required — ever
                  </span>
                </li>
              </ul>
            </div>

            {/* Individual */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full relative" data-id="element-4321">
              <div className="mb-6" data-id="element-4322">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-4323">
                  Individual
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-4324">
                  Full access for one person
                </p>
              </div>
              <div className="mb-8" data-id="element-4325">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-4326">
                  {isAnnual ? '$79' : '$7.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-4327">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-4328">
                    Save $16/year
                  </p>}
              </div>
              <Link to="/onboarding" className="w-full block text-center py-3 px-4 bg-[#1a0647] text-white font-bold rounded-lg hover:bg-[#2d0b75] transition-colors mb-8" data-id="element-4329">
                Choose Individual
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-4330">
                <li className="flex items-start" data-id="element-4331">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4332" />
                  <span className="text-gray-700 text-sm" data-id="element-4333">For 1 person</span>
                </li>
                <li className="flex items-start" data-id="element-4334">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4335" />
                  <span className="text-gray-700 text-sm" data-id="element-4336">
                    Everything in Foundation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4337">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4338" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-4339">
                    Full access to all 39 guided walkthroughs
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4340">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4341" />
                  <span className="text-gray-700 text-sm" data-id="element-4342">
                    Ongoing check-ins and reminders to keep habits on track
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4343">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4344" />
                  <span className="text-gray-700 text-sm" data-id="element-4345">
                    Personalized action queue — always know what to do next
                  </span>
                </li>
              </ul>
            </div>

            {/* Family (Best Value) */}
            <div className="bg-white rounded-2xl p-8 border-2 border-[#631bb7] shadow-xl flex flex-col h-full relative transform md:-translate-y-4" data-id="element-4346">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#631bb7] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-4347">
                Best Value
              </div>
              <div className="mb-6 mt-2" data-id="element-4348">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-4349">Family</h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-4350">
                  Complete protection for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-4351">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-4352">
                  {isAnnual ? '$199' : '$19.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-4353">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-4354">
                    Save $40/year
                  </p>}
              </div>
              <Link to="/onboarding" className="w-full block text-center py-3 px-4 bg-[#631bb7] text-white font-bold rounded-lg hover:bg-[#521099] transition-colors mb-8 shadow-md" data-id="element-4355">
                Choose Family
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-4356">
                <li className="flex items-start" data-id="element-4357">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4358" />
                  <span className="text-gray-700 text-sm font-bold" data-id="element-4359">
                    Up to 6 people
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4360">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4361" />
                  <span className="text-gray-700 text-sm" data-id="element-4362">
                    Everything in Individual
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4363">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4364" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-4365">
                    One dashboard to coordinate safety across your whole
                    household
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4366">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4367" />
                  <span className="text-gray-700 text-sm" data-id="element-4368">
                    Each person gets their own guided path
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4369">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4370" />
                  <span className="text-gray-700 text-sm" data-id="element-4371">
                    You can see where everyone stands — and help where needed
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4372">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4373" />
                  <span className="text-gray-700 text-sm" data-id="element-4374">
                    No one falls through the cracks
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Lifetime Offer Section */}
      <section className="w-full bg-[#1a0647] py-16 md:py-24 relative overflow-hidden" data-id="element-4375">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-4376">
          <div className="absolute top-10 left-10 w-64 h-64 bg-[#8041bf] rounded-full filter blur-3xl" data-id="element-4377"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#00f4f8] rounded-full filter blur-3xl" data-id="element-4378"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-4379">
          <div className="text-center mb-12" data-id="element-4380">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-4381">
              For our first 1,000 families: lifetime access at a founder's
              price.
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-4382">
              One payment. All future updates included. When we add new
              walkthroughs, new check-ins, and new protections — you get them
              automatically. This pricing goes away at 1,000 members.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-4383">
            {/* Lifetime Individual */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl p-8 border border-white border-opacity-20 hover:bg-opacity-15 transition-all" data-id="element-4384">
              <div className="flex items-center justify-between mb-6" data-id="element-4385">
                <h3 className="text-2xl font-bold text-white" data-id="element-4386">
                  Lifetime Individual
                </h3>
                <User className="text-[#00f4f8] w-8 h-8" data-id="element-4387" />
              </div>
              <div className="mb-6" data-id="element-4388">
                <span className="text-5xl font-extrabold text-white" data-id="element-4389">$199</span>
                <p className="text-[#00f4f8] font-medium mt-2" data-id="element-4390">
                  One-Time Payment
                </p>
              </div>
              <p className="text-gray-300 mb-8" data-id="element-4391">
                Includes all future updates to the Individual Plan.
              </p>
              <button className="w-full py-4 px-6 bg-white text-[#1a0647] font-bold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-4392">
                Get Lifetime Individual
              </button>
            </div>

            {/* Lifetime Family */}
            <div className="bg-gradient-to-br from-[#631bb7] to-[#521099] rounded-2xl p-8 border border-white border-opacity-20 shadow-2xl transform md:scale-105" data-id="element-4393">
              <div className="flex items-center justify-between mb-6" data-id="element-4394">
                <h3 className="text-2xl font-bold text-white" data-id="element-4395">
                  Lifetime Family
                </h3>
                <Users className="text-white w-8 h-8" data-id="element-4396" />
              </div>
              <div className="mb-6" data-id="element-4397">
                <span className="text-5xl font-extrabold text-white" data-id="element-4398">$599</span>
                <p className="text-white text-opacity-90 font-medium mt-2" data-id="element-4399">
                  One-Time Payment
                </p>
              </div>
              <p className="text-white text-opacity-80 mb-8" data-id="element-4400">
                Includes all future updates to the Family Plan for up to 6
                members.
              </p>
              <button className="w-full py-4 px-6 bg-[#00f4f8] text-[#1a0647] font-bold rounded-lg hover:bg-[#00e0e4] transition-colors shadow-lg" data-id="element-4401">
                Get Lifetime Family
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Competitive Comparison */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-4402">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4403">
          <div className="text-center mb-12" data-id="element-4404">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-4405">
              Why Overpay for Anxiety When You Can Invest in Capability?
            </h2>
          </div>

          <div className="overflow-x-auto" data-id="element-4406">
            <table className="w-full max-w-5xl mx-auto border-collapse" data-id="element-4407">
              <thead data-id="element-4408">
                <tr data-id="element-4409">
                  <th className="text-left py-4 px-6 font-bold text-gray-500 uppercase text-sm tracking-wider border-b-2 border-gray-100" data-id="element-4410"></th>
                  <th className="text-left py-4 px-6 border-b-2 border-[#631bb7]" data-id="element-4411">
                    <div className="text-xl font-bold text-[#631bb7]" data-id="element-4412">
                      Caveo
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-4413">
                    <div className="text-xl font-bold text-gray-600" data-id="element-4414">
                      Norton 360 / Aura
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-4415">
                    <div className="text-xl font-bold text-gray-600" data-id="element-4416">
                      Geek Squad
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-4417">
                {[{
                label: 'Philosophy',
                caveo: 'Gets the important things done — and keeps them done',
                competitor1: 'Sells reactive alerts & fear',
                competitor2: 'Profits from your tech breaking'
              }, {
                label: 'Cost',
                caveo: 'Starts at $7.99/mo',
                competitor1: '$12 - $35/mo',
                competitor2: '$99+ per incident'
              }, {
                label: 'Experience',
                caveo: 'Step-by-step walkthroughs anyone can follow',
                competitor1: 'Confusing technical jargon',
                competitor2: 'In-person visit required'
              }, {
                label: 'Incentive',
                caveo: 'We win when you feel confident',
                competitor1: 'They win when you stay anxious',
                competitor2: 'They win when you have problems'
              }, {
                label: 'Outcome',
                caveo: "A family that's actually protected — not just subscribed to something",
                competitor1: 'Dependency & Confusion',
                competitor2: 'A temporary fix'
              }].map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-4418">
                    <td className="py-6 px-6 font-bold text-[#111111]" data-id="element-4419">
                      {row.label}
                    </td>
                    <td className="py-6 px-6 font-medium text-[#631bb7] bg-[#631bb7] bg-opacity-5" data-id="element-4420">
                      {row.caveo}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-4421">
                      {row.competitor1}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-4422">
                      {row.competitor2}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-4423">
        <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-4424">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-12 text-center" data-id="element-4425">
            Your Questions, Answered.
          </h2>
          <div className="space-y-6" data-id="element-4426">
            {[{
            q: 'Can I cancel my subscription at any time?',
            a: 'Yes. You can cancel your monthly or annual plan at any time from your account settings. No questions asked. Your plan will remain active until the end of the current billing period.'
          }, {
            q: 'What happens when you add new modules or features?',
            a: "All new modules and feature updates are included in the Individual, Family, and Lifetime plans at no extra cost. Our platform is constantly evolving to meet new threats, and you'll always have the latest protection."
          }, {
            q: 'How does the Family Plan work for different family members?',
            a: "The Family Plan gives you a central dashboard to invite up to 5 other family members. You can use our role-based views to see different information; for example, an adult child can see their parent's progress and help them with tasks, while the parent sees a simplified view focused on their own learning."
          }, {
            q: 'Is the Free (Foundation) plan free forever?',
            a: "Yes. The Foundation plan is free forever. It's a great way to get started with our basic security assessment and introductory modules to see how Caveo works."
          }, {
            q: 'What if I’m not satisfied?',
            a: "We offer a 30-day money-back guarantee on all paid plans, including lifetime memberships. If you're not happy for any reason, just let us know within 30 days of your purchase for a full refund."
          }].map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm" data-id="element-4427">
                <h3 className="text-lg font-bold text-[#111111] mb-2" data-id="element-4428">
                  {faq.q}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4429">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-4430">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-4431">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-4432">
            Start free. See what your family hasn't done yet. Upgrade whenever
            you're ready.
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10" data-id="element-4433">
            No email required. No credit card. Just a clear picture of where you
            stand — in 3 minutes.
          </p>
          <Link to="/onboarding" className="inline-block bg-[#631bb7] text-white px-10 py-4 rounded-lg font-bold text-lg hover:bg-[#521099] transition-all shadow-lg transform hover:-translate-y-1" data-id="element-4434">
            Get Started for Free
          </Link>
        </div>
      </section>

      <Footer data-id="element-4435" />
    </div>;
}